// extracted by mini-css-extract-plugin
module.exports = {"container-memory":"GameMemory_container-memory__5QLCz"};